import universalImport from 'babel-plugin-universal-import/universalImport';
import universal from 'react-universal-component';
import path from 'path';
import LazyComponent from './LazyComponent';

const importResource = universalImport({
    chunkName: () => 'LazyCustomerInfoChunks',
    path: () => path.join(__dirname, './CustomerInformationConnect'),
    resolve: () => require.resolveWeak('./CustomerInformationConnect'),
    load: () =>
        Promise.all([
            import('./CustomerInformationConnect'), // css name
        ]).then((proms) => proms[0]),
});

export default universal(importResource, LazyComponent.loaderResource);
